module.exports = __webpack_public_path__ + "img/bg-upload.c41b1bde.png";